import Toastify from 'toastify-js';

const commonToastConfig = {
    duration: 7000,
    close: true,
    gravity: "bottom",
    position: "right",
    stopOnFocus: true, // Prevents dismissing of toast on hover
}

export let MessageDisplayerUtility = {
    error: function (message: string, additionalConfig = {}) {
        let toastifyConfig = {
            text: message,
            className: 'error-message',
            onClick: function () {
                errorToast.hideToast();
            },
            ...commonToastConfig,
            ...additionalConfig
        } as Toastify.Options
        let errorToast = Toastify(toastifyConfig)
        errorToast.showToast();
    },

    success: function (message: string, additionalConfig = {}) {
        let toastifyConfig = {
            text: message,
            className: 'success-message',
            onClick: function () {
                successToast.hideToast();
            },
            ...commonToastConfig,
            ...additionalConfig
        } as Toastify.Options
        let successToast = Toastify(toastifyConfig)
        successToast.showToast();
    },
};
